$('document').ready(() => {
  $('#duca_cookie_button').click(() => {
    // Lasts for one year, like the EU consent cookie
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    document.cookie = `duca_accepted=true; SameSite=Lax; expires=${date.toUTCString()}`;
    $('#duca_cookie_banner').hide();
  });
});
